module.exports = __webpack_public_path__ + "static/media/logo.4149b25e.png";